module.exports = __webpack_public_path__ + "static/media/review-salary-worker-second.7e2239fb.jpg";